import React from 'react';
import IconButton from '@mui/material/IconButton';
import PreviewIcon from '@mui/icons-material/Preview';
import ShareIcon from '@mui/icons-material/Share';
import Tooltip from '@mui/material/Tooltip';

interface PreviewButtonsProps {
  editMode: boolean;
  openPagePreview: () => void;
  openCoursePreview: () => void;
  openShareDialog: () => void;
}

const PreviewButtons = ({ editMode, openPagePreview, openCoursePreview, openShareDialog }: PreviewButtonsProps) => {
  return (
    <div>
      <Tooltip title={editMode ? 'Preview Page' : 'Preview Course'}>
        <IconButton size='small' onClick={editMode ? openPagePreview : openCoursePreview}>
          <PreviewIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={'Shareable Preview Link'}>
        <IconButton size='small' onClick={openShareDialog}>
          <ShareIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default PreviewButtons;
